import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Badge, Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

const DEFAULT_DELETION_NOTE = 'Fake / Not Authentic'

const propTypes = {
  isOpen             : PropTypes.bool.isRequired,
  toggle             : PropTypes.func.isRequired,
  sku                : PropTypes.string,
  handleConfirmation : PropTypes.func.isRequired
}

const defaultProps = {
  sku: 'This product'
}

const SwapBkrToBkxConfirmationModal = ({
  isOpen,
  toggle,
  sku,
  handleConfirmation
}) => {
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const [ deletionNote, setDeletionNote ] = useState(DEFAULT_DELETION_NOTE)

  useEffect(() => {
    if (isOpen) {
      setIsSubmitting(false)
      setDeletionNote(DEFAULT_DELETION_NOTE)
    }
  }, [ isOpen ])

  const handleConfirm = async () => {
    const note = deletionNote.toString().trim()
    if (!note || isSubmitting) return

    setIsSubmitting(true)

    try {
      await handleConfirmation(note)
    } catch (error) {
      setIsSubmitting(false)
      return error
    }
  }

  return (
    <Modal isOpen={ isOpen } toggle={ isSubmitting ? undefined : toggle } centered size='lg'>
      <ModalHeader toggle={ isSubmitting ? undefined : toggle }>
        Mark BKR as BKX / Fake
      </ModalHeader>

      <ModalBody>
        <div className='mb-4'>
          <div className='d-flex align-items-center mb-3'>
            <Badge color='warning' pill className='px-3 py-2 mr-2'>BKR</Badge>
            <i className='fas fa-arrow-right text-muted mr-2' />
            <Badge color='danger' pill className='px-3 py-2 mr-3'>BKX</Badge>
            <span className='font-weight-bold text-dark'>{ sku || 'This product' }</span>
          </div>

          <p className='mb-0 text-muted'>
            Gunakan hanya untuk BKR yang sudah terkonfirmasi fake / not authentic. Product yang sama akan direcode ke BKX agar ownership dan physical inventory history tetap tersambung.
          </p>
        </div>

        <FormGroup>
          <Label className='font-weight-bold'>Reason / Note <span className='text-danger'>*</span></Label>
          <Input
            type='textarea'
            rows='3'
            value={ deletionNote }
            disabled={ isSubmitting }
            onChange={ (event) => setDeletionNote(event.target.value) }
          />
        </FormGroup>

        <div className='border rounded p-3 mb-3 bg-light'>
          <div className='font-weight-bold mb-2'>Yang akan dilakukan sistem</div>
          <ul className='mb-0 pl-3 text-muted'>
            <li>SKU direcode dari BKR menjadi BKX dengan serial yang sama bila target SKU tersedia.</li>
            <li>Inventory record tetap sama; IQ tetap untuk physical tracking dan Consignor Return.</li>
            <li>SQ dibuat 0 dan inventory dinonaktifkan supaya product tidak dapat dijual.</li>
            <li>Authentication Status diubah menjadi <strong>Not Authentic</strong>.</li>
            <li>Inventory Movement <strong>Mark BKR as BKX</strong> dan audit log akan dibuat.</li>
          </ul>
        </div>

        <div className='alert alert-danger mb-0'>
          Proses ini bukan delete biasa dan tidak otomatis dapat di-undo. Pastikan hasil authentication sudah final sebelum confirm.
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color='secondary' disabled={ isSubmitting } onClick={ toggle }>
          Cancel
        </Button>
        <Button color='danger' disabled={ isSubmitting || !deletionNote.toString().trim() } onClick={ handleConfirm }>
          { isSubmitting ? 'Processing...' : 'Confirm BKX' }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

SwapBkrToBkxConfirmationModal.propTypes = propTypes
SwapBkrToBkxConfirmationModal.defaultProps = defaultProps

export default SwapBkrToBkxConfirmationModal
